import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import useAllParticipants from '../hooks/useAllParticipants';
import LoadingArea from '@molecules/LoadingArea';

export const ConversationsListContext = createContext();

const ConversationParticipantsProvider = ({ children }) => {
    const { allParticipantIdentities } = useAllParticipants();

    if (!allParticipantIdentities) return <LoadingArea />;

    return (
        <ConversationsListContext.Provider value={{ allParticipantIdentities }}>
            {children}
        </ConversationsListContext.Provider>
    );
};
ConversationParticipantsProvider.propTypes = {
    children: PropTypes.any,
};

export default ConversationParticipantsProvider;
